import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import stylesheet, { blue } from 'src/constants/stylesheet';
import Flickity, { FlickityOptions } from 'react-flickity-component';
import Image from '../Image';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            position: 'relative',
            overflow: 'hidden',
            '@global': {
                '.flickity-page-dots': {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 'calc(21px + 6%)',
                    display: 'flex',
                    justifyContent: 'center',
                    listStyle: 'none',
                },
                '.flickity-page-dots .dot': {
                    margin: '0 5px',
                    width: 14,
                    height: 14,
                    opacity: 1,
                    background: 'white',
                    border: `1px solid ${blue}`,
                    borderRadius: '100%',
                    cursor: 'pointer',
                },
                '.flickity-page-dots .dot.is-selected': {
                    background: blue,
                },
                '.flickity-button': {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    width: '33.3333%',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',

                    '& svg': {
                        display: 'none'
                    },
                    '&.next': {
                        right: 0,
                    },
                    '&.previous': {
                        left: 0,
                    }
                },
            },
        },
        slide: {
            position: 'relative',
            width: '100%',
        },
        figure: {
            position: 'relative',
            width: '100%',
            height: 0,
            paddingBottom: '50%',
            overflow: 'hidden'
        },
        figureInner: {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
        },
        legend: {
            ...stylesheet.Credits,
            marginTop: 8
        },
        link: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        tooltip: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            backgroundColor: 'white',
            padding: '5px 10px 4px 10px',
            borderRadius: 4,
            display: 'none',
            fontSize: '.85rem',

            '&:hover': {
                display: 'block'
            },

            '$link:hover + &': {
                display: 'block'
            },
        },
    }));

export type PanelImagesProps = PanelImagesDto;
type Props = PanelImagesProps;

const PanelImages: FC<Props> = ({ Images, Link: link }) => {
    const cls = useStyles();

    const flickityOptions: FlickityOptions = {
        cellAlign: 'left',
        pageDots: Images.length > 1,
        prevNextButtons: (link.length <= 0 && Images.length > 1) || false
    }

    const isInternal = link.length > 0 && link.startsWith("/");

    return (
        <div className={cls.root}>
            <Flickity
                className={'carousel'} // default ''
                elementType={'div'} // default 'div'
                options={flickityOptions} // takes flickity options {}
                disableImagesLoaded={false} // default false
            >
                {Images.length > 0 && Images.map((image, i) =>
                    <div
                        className={cls.slide}
                        key={`figure-${i}`}
                    >
                        <div className={cls.figure}>
                            <figure className={cls.figureInner}>
                                <Image
                                    className={cls.image}
                                    pictureRef={image}
                                    // TODO: sizes
                                    sizes={"100vw"}
                                />

                                {link && !isInternal && <a href={link} className={cls.link} target={'_blank'} />}
                                {link && isInternal &&
                                    <Link to={link} className={cls.link} />
                                }
                                {
                                    // link && <div className={cls.tooltip}>{link}</div>
                                }
                            </figure>
                        </div>
                        {image.Legend &&
                            <figcaption className={cls.legend}>{image.Legend}</figcaption>
                        }
                    </div>
                )}
            </Flickity>
        </div>
    );
}

export default PanelImages;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelImages.tsx